import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    venue: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    var response = await API.venue.create (payload);
    //update list after screener is crated
    await context.dispatch ('list');
    return response;
  },

  async get (context, payload) {
    /* if not in state get from api */
    var response = await API.venue.get (payload);
    return response;
  },

  async delete (context, payload) {
    var response = await API.venue.delete (payload);
    return response;
  },

  async list (context, payload) {
    var response = await API.venue.list (payload);
    // set venues in list
    context.commit ('set_list', {
      venues: response.venues,
    });
    return response;
  },

  async update (context, payload) {
    var response = await API.venue.update (payload);
    await context.dispatch ('list');
    return response;
  },

  async updateSeats (context, payload) {
    var response = await API.venue.updateSeats (payload);
    return response;
  },

  async markUnavailableSeats (context, payload) {
    var response = await API.venue.markUnavailableSeats (payload);
    return response;
  },

  async markAvailableSeats (context, payload) {
    var response = await API.venue.markAvailableSeats (payload);
    return response;
  },

  async markSeatsInaccessible (context, payload) {
    var response = await API.venue.markSeatsInaccessible (payload);
    return response;
  },
  async markSeatsAccessible (context, payload) {
    var response = await API.venue.markSeatsAccessible (payload);
    return response;
  },
  async duplicateVenue (context, payload) {
    var response = await API.venue.duplicateVenue (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getVenue: state => id => {
    var venue = null;
    if(state.list.data){
      venue = state.list.data.find (venue => {
        return venue.id == id;
      });
    }
    return venue;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.venues;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
